import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { ApiAuthService } from './api-auth.service';
import { toApiErrorViewModel } from './api-error.util';
import { ApiSessionService } from './api-session.service';

/** Keeps authentication failures deterministic without exposing HttpErrorResponse to UI code. */
export const apiErrorInterceptor: HttpInterceptorFn = (request, next) => next(request).pipe(
  catchError((error: HttpErrorResponse) => {
    if (error.status === 401) {
      const auth = inject(ApiAuthService);
      const session = inject(ApiSessionService);
      const isAuthRequest = /\/api\/v1\/auth\/(login|refresh|logout)$/.test(request.url);
      if (!isAuthRequest && auth.refreshToken()) {
        return auth.refresh().pipe(
          switchMap(tokens => next(request.clone({ setHeaders: { Authorization: `Bearer ${tokens.accessToken}` } }))),
          catchError(refreshError => { auth.clear(); session.clearProfile(); return throwError(() => refreshError); }),
        );
      }
      auth.clear();
      session.clearProfile();
    }
    Object.assign(error, { apiError: toApiErrorViewModel(error) });
    return throwError(() => error);
  }),
);
